/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleHalfVertical = createReactComponent(
  "circle-half-vertical",
  "IconCircleHalfVertical",
  [
    ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
    ["path", { d: "M3 12h18", key: "svg-1" }]
  ]
);

export { IconCircleHalfVertical as default };
//# sourceMappingURL=IconCircleHalfVertical.js.map
